import { GET_WRITING_IMPLEMENT_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WRITING_IMPLEMENT_TYPES_SUCCESS: {
      const writingImplementTypes = action.payload;

      if (!writingImplementTypes){
        return [...state];
      }

      return [
        ...state,
        ...writingImplementTypes
      ]
    }
    default:
      return state;
  }
}
